import { AppSizes } from '../../config/sizes';
import { InjectionToken } from '@angular/core';

export const SIZES_TOKEN = new InjectionToken<AppSizes>('SIZES_TOKEN');
